import { render, staticRenderFns } from "./AddWarning.vue?vue&type=template&id=f080484e&scoped=true&"
import script from "./AddWarning.vue?vue&type=script&lang=js&"
export * from "./AddWarning.vue?vue&type=script&lang=js&"
import style0 from "./AddWarning.vue?vue&type=style&index=0&id=f080484e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f080484e",
  null
  
)

export default component.exports